import actionTypes from './actionTypes';

export const resetSelectedStore = () => ({
  type: actionTypes.RESET_STORE,
});

export const setSelectedStore = (store) => ({
  type: actionTypes.SELECT_STORE,
  payload: store,
});

export default setSelectedStore;
